/* eslint-disable import/no-cycle */
import React from 'react';
import styled from 'styled-components';
import QuestionRenderer from '../../QuestionRenderer';

const ImageTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 1024px) {
    flex-direction: row;
    padding: 10px;
    justify-content: space-evenly;
  }
`;

const ImageLabelWrapper = styled.div`
  padding: 25px 30px 10px;
  @media (max-width: 1024px) {
    padding: 30px 20px;
    width: 50%;
    margin-right: 20px;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  & img {
    width: 100%;
  }
  @media (max-width: 1024px) {
    padding: 30px 20px 0 0;
    margin: 10px 0;
    width: 50%;
  }
`;

const ImageText = ({ questionObj }) => {
  const { questions = [], desktop_image_url: imgSrc = '' } = questionObj || {};

  const remoteSrcRegex = /^((http|https):\/\/)?([\w.]+)\/([\w/]+)(.jpg|.png|.webp|.jpeg)$/g;
  // eg for remote image src: https://domain/path/subpath.jpg

  const isRemoteSrc = imgSrc?.match(remoteSrcRegex);

  return (
    <ImageTextWrapper>
      <ImageLabelWrapper>
        {Array.isArray(questions) && <QuestionRenderer questionList={ questions } rebuild={ false } />}
      </ImageLabelWrapper>
      <ImageWrapper>
        <img src={ isRemoteSrc ? imgSrc : `/images/${imgSrc}` } alt='' width='320' height='100%' />
      </ImageWrapper>
    </ImageTextWrapper>
  );
};

export default React.memo(ImageText);
